import PubSub from 'pubsub-js';
import { HIRO_EVENT_NAME } from '../config';
import type { IEventProxy, SummaryParams, TranslateParams } from '../types';

export class HiroEventProxy implements IEventProxy {
    constructor() {
        // TODO 初始化
    }

    public emitHiroLoaded() {
        PubSub.publish(HIRO_EVENT_NAME.HIRO_LOADED);
    }

    public onHiroLoaded(mySubscriber: (message: string) => void) {
        const token = PubSub.subscribe(
            HIRO_EVENT_NAME.HIRO_LOADED,
            mySubscriber,
        );
        return token;
    }

    public emitSummary(data: SummaryParams) {
        PubSub.publish(HIRO_EVENT_NAME.SUMMARY, data);
    }

    public onSummary(
        mySubscriber: (message: string, data: SummaryParams) => void,
    ) {
        const token = PubSub.subscribe(HIRO_EVENT_NAME.SUMMARY, mySubscriber);
        return token;
    }

    public emitTranslate(data: TranslateParams) {
        PubSub.publish(HIRO_EVENT_NAME.TRANSLATE, data);
    }

    public onTranslate(
        mySubscriber: (message: string, data: TranslateParams) => void,
    ) {
        const token = PubSub.subscribe(HIRO_EVENT_NAME.TRANSLATE, mySubscriber);
        return token;
    }

    public emitNewChat() {
        PubSub.publish(HIRO_EVENT_NAME.NEW_CHAT);
    }

    public onNewChat(mySubscriber: (message: string) => void) {
        const token = PubSub.subscribe(HIRO_EVENT_NAME.NEW_CHAT, mySubscriber);
        return token;
    }

    public clearSubscription(token: PubSubJS.Token) {
        if (token) {
            PubSub.unsubscribe(token);
        }
    }

    public clearAllSubscriptions() {
        PubSub.clearAllSubscriptions();
    }
}
